import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {AdService} from '@services/ad.service';
import {TrackingService} from '@services/tracking.service';
import {environment} from '~/environments/environment';
import {HttpClient} from '@angular/common/http';
import {AuthenticationService} from '@services/authentification.service';
import {Router} from '@angular/router';

@Component({
    selector: 'app-delete-user',
    templateUrl: './delete-user.component.html',
    styleUrls: ['./delete-user.component.scss']
})
export class DeleteUserComponent implements OnInit {

    loading = false;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        private http: HttpClient,
        private authenticationService: AuthenticationService,
        private router: Router,
        public dialogRef: MatDialogRef<DeleteUserComponent>) {
    }

    ngOnInit(): void {
    }

    onNoClick(): void {
        this.dialogRef.close(false);
    }

    onYesClick(): void {
        this.http.delete<any>(`${environment.apiUrl}app/user`, {}).subscribe(
            result => {
                this.dialogRef.close();
                this.loading = false;
                this.authenticationService.logout();
                this.router.navigate(['/app/login']);
            },
            (error) => {
                this.loading = false;
            });
    }
}
